/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_S1Inputs */

const en_tut_proyek_s1 = /** @type {(inputs: Tut_Proyek_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Proyek** in the left menu, create a new project, name it something like *Ramadan campaign*, and pick an owner.`)
};

const id_tut_proyek_s1 = /** @type {(inputs: Tut_Proyek_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Proyek** di menu kiri, tekan buat proyek baru, beri nama seperti *Kampanye Ramadan*, lalu tentukan pemiliknya.`)
};

/**
* | output |
* | --- |
* | "Open **Proyek** in the left menu, create a new project, name it something like *Ramadan campaign*, and pick an owner." |
*
* @param {Tut_Proyek_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_s1 = /** @type {((inputs?: Tut_Proyek_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_s1(inputs)
	return en_tut_proyek_s1(inputs)
});